import React from "react";
import { findEnumObject } from "utilities/enumutils";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
}

const GetTypeLabel = (props: Props) => {
  if (props.nextSubscriptionType.value === "cancelledByClient" || props.nextSubscriptionType.value === "cancelledBySystemOne") {
    return "Subscription cancelled";
  }

  if (props.activeSubscription.type === "paid" || props.activeSubscription.type === "free") {
    return RESX.Subscription.resxSubscription;
  }

  // Due to serverReference.subscriptionTypes being type-narrowed (after the `if` checks), we need to cast it to its full type again
  return findEnumObject(props.activeSubscription.type as server.dto.SubscriptionTypes, serverReference.subscriptionTypes).text;
};

const SubscriptionPanelHeader = (props: Props) => {
  const daysUntilEndText = () => (props.activeSubscription.daysUntilEnd === 1
    ? RESX.DateTime.OneDayLeft
    : RESX.DateTime.XDaysLeft.replace("{0}", props.activeSubscription.daysUntilEnd.toString())
  );

  const daysLeftCssClass = () => (props.activeSubscription.daysUntilEnd > 7
    ? "s1_gray"
    : "red");

  const typeLabel = GetTypeLabel(props);

  const displayDaysLeft = () => (props.nextSubscriptionType.value === "readOnly" ||
    props.nextSubscriptionType.value === "cancelledByClient" ||
    props.nextSubscriptionType.value === "cancelledBySystemOne" ||
    props.nextSubscriptionType.value === "trialEnd");

  return <div className="flex">
    <div className="grow1">
      <h1 className="nav-text-semibold">{typeLabel}</h1>
    </div>
    {displayDaysLeft() && <div style={{
      display: "flex",
      alignItems: "center",
      marginLeft: 2,
    }} className={daysLeftCssClass()}>
      <h3>
        {daysUntilEndText()}
      </h3>
    </div>}
  </div>;
};

export default SubscriptionPanelHeader;